import { useEffect, useState } from "react";
import { getHomePageData } from "../api/home-page";
import { getHostingPlans } from "../api/global";
import Loading from "../components/loading";
import Intro from '../components/home-page/Intro/';
import Services from "../components/home-page/Services/";
import Map from "../components/home-page/Map/";
import HostingPlans from "../components/home-page/HostingPlans/";
import QuestionList from "../components/home-page/QuestionList/";
import RegisterBanner from "../components/home-page/RegisterBanner/";
import CookiesModal from "../components/cookies-modal";

export default function HomePage() {
    const [loading, setLoading] = useState(true);
    const [introData, setIntroData] = useState(null);
    const [servicesData, setServicesData] = useState(null);
    const [mapData, setMapData] = useState(null);
    const [hostingPlansHeading, setHostingPlansHeading] = useState(null);
    const [hostingPlans, setHostingPlans] = useState(null);
    const [questionData, setQuestionData] = useState(null);
    const [registerBannerData, setRegisterBannerData] = useState(null);
    const [cookiesAccepted, setCookiesAccepted] = useState(true);

    const [billingType, setBillingType] = useState("monthly");

    useEffect(() => {
        const loadingData = async () => {
            const data = await getHomePageData();
            setIntroData(data.intro);
            setServicesData(data.services);
            setMapData(data.map);
            setHostingPlansHeading(data.hostingPlansHeading);
            setQuestionData(data.question);
            setRegisterBannerData(data.registerBanner);
            setHostingPlans(await getHostingPlans());
            setLoading(false);
        };

        loadingData();
        sessionStorage.removeItem('searched-domain');
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const cookiesAccepted = localStorage.getItem('cookies_accepted');
        if (!cookiesAccepted) {
            setCookiesAccepted(false);
        }
    }, []);

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="HomePage">
            {!cookiesAccepted && <CookiesModal setCookiesAccepted={setCookiesAccepted} />}
            {introData && <Intro introData={introData} />}
            {servicesData && <Services servicesData={servicesData} />}
            {mapData && <Map mapData={mapData} />}
            {hostingPlansHeading && hostingPlans && <HostingPlans hostingPlansHeading={hostingPlansHeading} hostingPlans={hostingPlans} billingType={billingType} setBillingType={setBillingType} />}
            {questionData && <QuestionList questionData={questionData} />}
            {registerBannerData && <RegisterBanner registerBannerData={registerBannerData} />}
        </div>
    )
}